import { useCallback, useEffect, useState } from 'react'

export function usePreventTabClose() {
  const [isEnabled, setIsEnabled] = useState(true)

  const disable = () => {
    setIsEnabled(false)
  }

  const handler = useCallback(
    (event: BeforeUnloadEvent) => {
      if (isEnabled) {
        const message = 'User must stay at page before data will be sent'
        event.preventDefault() // Gecko, Trident, Chrome 34+
        event.returnValue = message // Gecko, WebKit, Chrome <34
        return message // Chrome <34
      }
    },
    [isEnabled]
  )

  useEffect(() => {
    window.addEventListener('beforeunload', handler)

    return () => {
      window.removeEventListener('beforeunload', handler)
    }
  }, [handler])

  return { disable }
}
